import { FeeConstants as Constants } from '../types'

const initialState = {
    fees: [],    
    months: [],
    total: 0,
    error: null,    
    loading: false   
};

export function feeReducer(state = initialState, action) {
    switch (action.type) {  

        case Constants.GET:                     
            return {
                ...state,
                fees: action?.payload?.fees,
                total: action?.payload?.total,
                loading: false,
                error: null,
            };

        case Constants.MONTHS:                     
            return {
                ...state,
                months: action?.payload?.months,
                loading: false,
                error: null,
            };

               
        case Constants.ADD:
            return {
                ...state,
                months: [action?.payload?.month, ...state?.months],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.fees.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.fee?.id))
            const newArray = [...state.fees];
            if(index > -1)
                newArray[index] = action?.payload?.fee
            return {
                ...state,
                fees: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                fees: state?.fees?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
            return{
                ...state,
                fees: []
            }
        default:
            return state
    }
}